import { css } from '@emotion/react'
import styled from '@emotion/styled'
import {
  Accordion,
  AccordionHeading,
} from '@yuno/sdk-web-core/dist/ui'

export const Container = styled.div`
  display: block;
`

export const PaymentMethodsContainer = styled.section`
  ${({ theme }) => `
  background-color: ${theme.colors.neutrals.w};
`}
`

export const Wrapper = styled.div`
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      justify-content: center;
    }
  `}
`

export const PaymentScroll = styled.div`
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      overflow-y: auto;
      overflow-x: hidden;
      height: 100%;
    }
  `}
`

export const SdkContent = styled.div``

export const PaymentMethod = styled(Accordion)`
  & ~ & {
    border-top: 1px solid #ECEFF2;
  }

  &[data-active='true'] {
    position: relative;
    z-index: 1;
    border: 1px solid var(--yuno-checkout-border-color, #ECEFF2);
    border-radius: 16px 16px 0 0;
    margin: -1px 0;
  }

  .Yuno-card-container,
  .yuno-user-form__form section {
    width: auto;
    padding: 0px 16px 16px;
  }

  .yuno-user-form__form section {
    max-width: initial;
    min-width: auto;
  }

  .yuno-grid-submit {
    margin: 0;
  }
`

export const PaymentMethodHeading = styled(AccordionHeading)`
  padding: 16px;

  .Yuno-accordion__heading-title {
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
  }
`

export const PaymentMethodName = styled.span`
  padding-left: 12px;
  ${({ theme }) => css(theme.typographys.small.regular)}
  color: ${({ theme }) => theme.colors.neutrals.b};
`

export const PaymentContent = styled.div`
  padding: 0 16px 16px 16px;
  box-sizing: border-box;
`
